import { render, staticRenderFns } from "./DocumentDoctorOrder.vue?vue&type=template&id=17782c04&scoped=true&"
import script from "./DocumentDoctorOrder.vue?vue&type=script&lang=js&"
export * from "./DocumentDoctorOrder.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDoctorOrder.vue?vue&type=style&index=0&id=17782c04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17782c04",
  null
  
)

export default component.exports